import { useTranslation } from 'react-i18next'

import { RequestEditStatusModal } from '../../RequestEditStatusModal'

import { ATTACH_SERVICE_REQUESTS_STATUS_ACTION_CONFIG } from './AttachServiceRequestsStatusModal.constants'
import {
  getAttachServiceRequestsStatusModalInitialNotifications,
  getAttachServiceRequestsStatusModalInitialValues,
  getAttachServiceRequestsStatusModalPayload,
} from './AttachServiceRequestsStatusModal.utils'
import { AttachServiceRequestsStatusModalFields } from './AttachServiceRequestsStatusModalFields'

import * as styles from './AttachServiceRequestsStatusModal.module.css'

function AttachServiceRequestsStatusModal({ action, onClose, onSubmit }) {
  const { t } = useTranslation()

  return (
    <RequestEditStatusModal
      Fields={AttachServiceRequestsStatusModalFields}
      containerProps={{ modalClassName: styles.modal }}
      formFieldsProps={{
        checkboxLabel:
          ATTACH_SERVICE_REQUESTS_STATUS_ACTION_CONFIG[action].checkboxLabel,
      }}
      getPayload={getAttachServiceRequestsStatusModalPayload}
      initialNotifications={getAttachServiceRequestsStatusModalInitialNotifications(
        action,
        t
      )}
      initialValues={getAttachServiceRequestsStatusModalInitialValues()}
      needToCheckNoChanges={false}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}

export default AttachServiceRequestsStatusModal
